import { isArray, isDefined, LineStringNode } from "../../infra3d";
import { Geometry, GEOMETRYTYPE, PickData } from "./internal";
/**
 * Representation of the FeatureCollection-Object specified in GeoJSON-Standard.
 *
 * @class FeatureCollection
 * @author Ported by Benjamin Loesch, based on code by Kevin Flueckiger
 * @extends Geometry
 */
export class MultiLineStringGeometry extends Geometry {
    constructor(parentfeature) {
        super(parentfeature);
        this.nodes = [];
        this.coordinates = [];
        this._coordinates = [];
        this.type = GEOMETRYTYPE.MULTILINESTRING;
        this.parent = parentfeature;
        this.scene = parentfeature.scene;
    }
    /**
     * Parse the Geometry from a JSON-Object
     * @method parseFromJSON
     * @param {Object} json The JSON Object
     */
    parseFromJSON(json) {
        if (isDefined(json["coordinates"])) {
            this.type = Geometry.toNumber(json["type"]);
            const ls = json["coordinates"];
            let bError = false;
            for (let j = 0; j < json["coordinates"].length; j++) {
                const ls = json["coordinates"][j];
                for (let i = 0; i < ls.length; i++) {
                    if (!isArray(ls[i]))
                        bError = true;
                }
            }
            // If the coordinate-Array is valid, assign it to the Geometries-Coorinate-Property.
            if (bError) {
                // something is wrong with this array!
                console.log("Something worng with coordinates array of linestringgeometry");
            }
            else {
                this.coordinates = json["coordinates"][0].slice(0);
                this._coordinates = json["coordinates"].slice(0);
                this._create();
            }
        }
    }
    _create() {
        for (const coords of this._coordinates) {
            if (coords.length > 0) {
                const node = new LineStringNode(coords, this.parent.style.toMaterialDefinitions(this.parent.properties), this);
                this.scene.add(node);
                this.nodes.push(node);
            }
        }
        this.created = true;
    }
    clear() {
        this.created = false;
        for (const node of this.nodes) {
            this.scene.remove(node);
        }
        this.nodes = [];
        this._coordinates = [];
        this.coordinates = [];
    }
    /**
     * returns the Geometry content as GeoJson string
     * @method toGeoJsonString
     * @return {string}
     */
    toGeoJsonString() {
        const objparts = {};
        objparts["type"] = Geometry.toString(this.type);
        objparts["coordinates"] = this._coordinates;
        return JSON.stringify(objparts);
    }
    /**
     * Removes the Geometry from the Render-Engine and destroys it.
     * @method destroy
     */
    destroy() {
        this.coordinates = [];
        this._coordinates = [];
        this.type = null;
        if (this.created) {
            for (const node of this.nodes) {
                this.scene.remove(node);
                node.destroy();
            }
            this.nodes = [];
        }
        this.id = null;
        this.created = false;
    }
    /**
     * Shows the geometry in Higlight-Style
     * @method highlightOn
     */
    highlightOn() {
        super.highlightOn();
        if (this.created) {
            for (const node of this.nodes) {
                node.setStyle(this.parent.highlightstyle.toMaterialDefinitions(this.parent.properties));
            }
        }
    }
    /**
     * Shows the geometry in Higlight-Style
     * @method highlightOff
     */
    highlightOff() {
        super.highlightOff();
        if (this.created) {
            for (const node of this.nodes) {
                node.setStyle(this.parent.style.toMaterialDefinitions(this.parent.properties));
            }
        }
    }
    /**
     * Updates the Geometry
     * @method update
     */
    update() {
        if (!this.created) {
            this._create();
        }
        else {
            for (const key in this.nodes) {
                const node = this.nodes[key];
                if (!this.parent.highlighton) {
                    node.setStyle(this.parent.style.toMaterialDefinitions(this.parent.properties));
                }
                else {
                    node.setStyle(this.parent.highlightstyle.toMaterialDefinitions(this.parent.properties));
                }
                if (this._coordinates?.[key]) {
                    const coords = this._coordinates[key];
                    node.updateCoordinates(coords);
                }
            }
        }
    }
    /**
     * Shows the Geometry. It sets hide to false and updates the geometry.
     * @method show
     */
    show() {
        super.show();
        if (this.created) {
            for (const node of this.nodes) {
                node.show();
            }
        }
    }
    /**
     * Hides the Geometry. It sets hide to true and updates the geometry.
     * @method hide
     */
    hide() {
        super.hide();
        if (this.created) {
            for (const node of this.nodes) {
                node.hide();
            }
        }
    }
    /**
     * Checks if the node was picked by mouse
     * @method hide
     */
    pick(mx, my, pickeddataarray) {
        if (this.created) {
            for (const node of this.nodes) {
                const p = node.pick(mx, my);
                if (p.length > 0) {
                    const pdata = new PickData();
                    pdata.feature = this.parentfeature;
                    pdata.mindist = p[0].distance;
                    pdata.mx = mx;
                    pdata.my = my;
                    pdata.found = true;
                    pdata.disttopoint = p[0].distance;
                    pdata.found_mx = p[0].point[0];
                    pdata.found_my = p[0].point[1];
                    pdata.geometry = this;
                    pickeddataarray.push(pdata);
                }
            }
        }
    }
}
//# sourceMappingURL=multilinestringgeometry.js.map